module.exports = __webpack_public_path__ + "static/media/S2N6-1.f00b4a16.svg";